import { ReactElement } from "react";
import * as React from "react";

import { AssetMetashotsType } from "../../../generated/gql/graphql";
import useText from "../../../hooks/use-text";
import { LocalizedStrings, SupportedLanguages } from "../../../utils/lang";
import MetaSelect from "../parts/meta-select";

type Props = {
  onChange(metashopType?: AssetMetashotsType): void;
};

export default function MetashotsTypeSelector(props: Props): ReactElement {
  const { onChange } = props;

  const { strings } = useText(local);

  const options = Object.keys(AssetMetashotsType).map((t) => t);

  return (
    <MetaSelect
      label={strings.label}
      name="value"
      getOptions={options}
      setOption={(v) => onChange(v["value"])}
      list={options.map((v) => ({ text: v, value: v }))}
    />
  );
}

type LocalSchema = {
  label: string;
};

const local: LocalizedStrings<LocalSchema, SupportedLanguages> = {
  default: {
    label: "Metashot Type",
  },
};
